import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Watermark() {
  const { user } = useAuth();
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 60000);
    return () => clearInterval(id);
  }, []);

  if (!user) return null;

  const text = `${user.name} · ${user.employeeId} · ${time.toLocaleDateString('en-IN')} ${time.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}`;

  // Build SVG pattern with diagonal repeating text
  const svgText = encodeURIComponent(`
    <svg xmlns='http://www.w3.org/2000/svg' width='320' height='180'>
      <text
        x='50%' y='50%'
        dominant-baseline='middle'
        text-anchor='middle'
        transform='rotate(-30, 160, 90)'
        font-family='system-ui, sans-serif'
        font-size='12'
        font-weight='500'
        fill='rgba(100,100,100,0.09)'
        letter-spacing='0.5'
      >${text}</text>
    </svg>
  `);

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        pointerEvents: 'none',
        backgroundImage: `url("data:image/svg+xml,${svgText}")`,
        backgroundRepeat: 'repeat',
        backgroundSize: '320px 180px',
        userSelect: 'none',
        WebkitUserSelect: 'none',
      }}
    />
  );
}
